export class WakeLockService {
	_wakeLock
	_supported = 'wakeLock' in navigator

	constructor() {
		if (!this._supported) {
			console.warn('Screen Wake Lock API not supported by this browser.')
			return
		}
		document.addEventListener('visibilitychange', this._onVisibilityChange)
		this.request()
	}

	request = () => {
		if (!this._supported || document.visibilityState !== 'visible') return
		navigator.wakeLock.request('screen')
			.then(wakeLock => {
				this._wakeLock = wakeLock
				console.debug('Screen wake lock acquired.')
				this._wakeLock.addEventListener('release', () => {
					console.debug('Screen wake lock released.')
				})
			})
			.catch(e => {
				console.warn('Failed to acquire screen wake lock: ', e)
			})
	}

	_onVisibilityChange = () => {
		// The wake lock is automatically released when the tab is hidden
		// (e.g. app switch, screen lock) - re-request once it's visible again.
		if (document.visibilityState === 'visible') {
			this.request()
		}
	}
}
